/**
 * @module client
 */

import createClientApp from './Client';

export * from './types';

export default createClientApp;
export * from './Client';



// WEBPACK FOOTER //
// ./src/client/index.ts